import React from 'react'
import {Spin, Tooltip, message, Button, } from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import PageCommon from  "@components/PageCommon/PageCommon";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import {toFixed} from "@/utils/number-util";
import { Link } from "react-router-dom"
import Lang from "@components/Lang/Lang";
import TransferAction from "../Transfer.action";
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import { toFixedWithCommas} from "@utils/number-util";
import OrderDetails from '../../../../components/ModalOrderDetails/OrderDetails';
import dayjs from 'dayjs';
import "./index.less"
/**
 * 待调拨 页签 | 使用统一的 查询表格组件
 *
 * @author FJJ
 * @version 2.0
 *
 * History:
 * Date      Version Remarks
 * ========= ======= ======================================================
 * 2022      1.0     First version Zhaoruji  => 备份在 index.bak.js
 * 2023      2.0    FJJ
 *
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class ToBeTransferTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading: false,
            list:[],//行
            extra: {},
            selectOrder:{},
            // 搜索默认
            searchStatus:0,
            // 表单 配置
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'toWarehouseId',
                    // cnTitle:'目的仓库',
                    // cnTitleId:'MuDiCangKu',
                    cnPlaceholder:'目的仓库',
                    cnPlaceholderId:'MuDiCangKu',
                    type:'SearchSelect',
                    searchClass:{
                        api:"/service/mg/allocate/warehouse-list",
                        nameField: 'transitCityName',
                        idField:'warehouseId',
                     },
                    width: 116,
                },
                {
                    name:'keyWord',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'搜索PO单号或客户编号',
                    cnPlaceholderId:'SouSuoPODanHaoHuoKeHuBianHao',
                    width:256,
                },
            ],
            columns:[
                {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    dataIndex: 'buyerCode',
                    render:(text, record, index) => (
                       record.buyerId?<Link className="num" to={`/customer/detail?id=${record.buyerId}`}>{text}</Link>:text
                    ),
                },
                {
                    cnTitle: 'PO单号',
                    dataIndex: 'poCode',
                    width: 200,
                    cnTitleId: 'PODingDan',
                    render:(code, record, index) => (<>
                        <p className={"black89 font-bold"}>{code}</p>
                        {record.poCode&&<LogisticsAndCabinetSwitch poId = {record.poId}
                            poCode={record.poCode}
                            containerCode={record.containerCode}
                            cabinetNum={record.cabinetNum}
                            logisticsData={record.pubOrderTrackVOS}
                        />}
                    </>)
                },
                {
                    cnTitle: '商品信息',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'ShangPinXinXi',
                    render:  (text, record, index) => (
                        <span>{record.totalSkuNum}{Lang({id:'Kuan', default:'款'})}，{record.totalQuantity}{Lang({id: 'Xiang', default: '箱'})}</span>
                    )
                },{
                    cnTitle: '总体积m³',
                    dataIndex: 'totalVolume',
                    cnTitleId: 'ZongTiJiM3',
                    render: (totalVolume, record) => <span className="content-text">{toFixedWithCommas(totalVolume, 3) || "-"}</span> //{" "}m³
                },
                {
                    cnTitle: '当前仓库',
                    cnTitleId: 'DangQianCangKu',
                    dataIndex: 'fromWarehouseName',
                },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'toWarehouseName',
                },
                {
                    cnTitle: '时间',
                    cnTitleId: 'ShiJian',
                    dataIndex: 'time',
                    render:(text, record, index) => (<>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'ZhuangGuiFaYunShiJian', default: '装柜发运时间'})}>
                                <i className="ri-truck-line mr_6 black33"></i>{record.loadDate ? dayjs(record.loadDate).format('YYYY-MM-DD') : '-'}
                            </Tooltip>
                        </p>
                   </> )
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 120,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<div>
                        <AuthBtn icon={"ri-edit-line"} tips = {Lang({id:"BianJi",default:"编辑"})}
                                 onClick={()=>this.getDeliveryListInfo(record.poId)}/>
                        <AuthBtn icon={"ri-delete-bin-line"} className={"ml_4"} tips = {Lang({id:"ShanChu",default:"删除"})}
                                       onClick={()=>this.getDeliveryListInfo(record.poId)}/>
                    </div>)},
            ],
            showTip: false,// 批量提示出库提示
        }
        this.intoWarehouseInfo = {}
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 获取单个出库详情*/
    getDeliveryListInfo(id) {
        this.loading(true)
        this.handleCloseDetails(true)
        TransferAction.postDeliveryListInfo({
            id,
        }).then(res => {
            this.loading(false)
            if (res.data.success && res.data.valid) {
                let order = res.data.model || {}
                this.setState({
                    selectOrder: {
                        ...order,
                        ids: [order.id],
                    },
                    extra: res.data.extra,
                })
            } else {
                message.info(res.data.message);
            }

        })
    }
    handleCloseDetails(flag=false){
        this.setState({
            showDetails:flag
        })
    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    // 查询回调
    fetchCallBack(res){
        const {success,valid,models,extra} = res;
        if (success && valid) {
            this.setState({
                list: models
            })
            if(this.props.changeNum&&extra)this.props.changeNum(extra.waitAllocateCount,extra.allocatingCount)
        }else this.setState({
            list: []
        })
        this.onRefPageCommonChild.isShowTop()
    }
    // 选择表格行
    setSelectedRowKeys(ids){
        this.setState({
            selectedRowKeys:ids
        })
    }
    onSelectChange = (newSelectedRowKeys) => {
        this.setSelectedRowKeys(newSelectedRowKeys);
    };
    // 批量调拔 弹窗
    batchDelivery(){
        const { selectedRowKeys,list } = this.state;
        let buyerCodeObj = {

        }
        if(selectedRowKeys&&selectedRowKeys.length>0){
            let selectOrder = {}
           let iQuantity=0, // 商品箱数
                iSkuNum= 0, // 商品款数
                iVolume= 0, // 体积
                iBuyerCode=0;

            // selectedRowKeys.forEach((item,inx) => {
            //
            // })
            for(let inx in selectedRowKeys){
                const item = selectedRowKeys[inx]
                const obj = list.find(row=>row.id==item)||{};
                iQuantity += (obj.totalQuantity||0);
                iSkuNum += (obj.totalSkuNum||0)
                iVolume += Number(obj.totalVolume)||0;
                if(inx==0){
                    selectOrder.fromWarehouseName = obj.fromWarehouseName;  //当前仓库
                    selectOrder.toWarehouseName = obj.toWarehouseName;  // 目的仓库
                }else {
                    if(selectOrder.fromWarehouseName!=obj.fromWarehouseName||selectOrder.toWarehouseName != obj.toWarehouseName){
                        message.warning(Lang({
                                id: "PiLiangDiaoBoDeDingDanCangKuShuJuXuYaoYiZhi",
                                default: "批量调拨的订单，仓库数据需要一致！",
                            })
                        )
                        return false;
                    }
                    if(selectOrder.fromWarehouseName!=obj.fromWarehouseName||selectOrder.toWarehouseName != obj.toWarehouseName){
                        message.warning(Lang({
                                id: "PiLiangDiaoBoDeDingDanCangKuShuJuXuYaoYiZhi",
                                default: "批量调拨的订单，仓库数据需要一致！",
                            })
                        )
                        return false;
                    }
                }
                const sBuyerCode= obj.buyerCode;
                if(buyerCodeObj[sBuyerCode]){
                    buyerCodeObj[sBuyerCode] += 1
                }else {
                    buyerCodeObj[sBuyerCode] = 1
                    iBuyerCode += 1;
                }
            }
            this.setState({
                selectOrder:{...selectOrder,
                    quantity: iQuantity, // 商品箱数
                    skuNum: iSkuNum, // 商品款数
                    volume: toFixed(iVolume,3), // 体积
                    buyerCode: iBuyerCode
                },
            })
            this.openBatchTransfer(true)
        }else message.warning(Lang({id:"QingXuanZeYaoCaoZuoDeShuJu",default:"请选择要操作的数据"}))
    }
    // 批量移出待出库
    batchAllocate(){
        const { selectedRowKeys,list } = this.state;
        if(selectedRowKeys&&selectedRowKeys.length>0){
            TransferAction.postBatchAllocate({
                ids: selectedRowKeys || []
            }).then(res => {
                const data = res.data || {};
                const { success, valid, } = data;
                if (success && valid) {
                    message.success(Lang({id:"CaoZuoChengGong",default:"操作成功"}));
                    this.onPageTemplateTableChild.handleFetch(1,{},true)
                } else if (!success||!valid) {
                    if(data.message){
                        message.info(data.message);
                    }else message.warning(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
                }
            })
        }else message.warning(Lang({id:"QingXuanZeYaoCaoZuoDeShuJu",default:"请选择要操作的数据"}))
    }
    /**
     * 打开 批量调拔*/
   openBatchTransfer(flag=false){
        this.setState({
            showTip: flag,
        })
    }
    batchTransfer() {
       const { selectedRowKeys } = this.state;
        TransferAction.submitTransfer({
            ids: selectedRowKeys || []
        }).then(res => {
            const data = res.data || {};
            const { success, valid, } = data;
            if (success &&valid) {
                message.success(Lang({id:"CaoZuoChengGong",default:"操作成功"}));
                this.onPageTemplateTableChild.handleFetch(1,{},true)
                this.openBatchTransfer()
            } else if (!success||!valid) {
                if(data.message){
                    message.info(data.message);
                }else message.warning(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
            }

        })
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    render() {
        const {loading, columns,searchFormOptions, selectedRowKeys, searchStatus, showTip, consignee, showDetails, extra,selectOrder} = this.state;
        // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
        return (<PageCommon onRef={this.onRefPageCommon} className={"transferWrap"} btnList={[
                {
                    btn: Lang({id:"DiaoBo",default:"调拨"}),
                    icon:"ri-share-forward-line mr_4 color-blue",
                    btnClick:()=>this.batchDelivery()
                },{
                    btn: Lang({id:"YiDaoDaiChuKu",default:"移到待出库"}),
                    icon:"ri-save-3-line color-green mr_4",
                    needConfirm: Lang({id:"QueDingYiDaoDaiChuKu",default:"确定移到待出库"})+"？",
                    btnClick:()=>this.batchAllocate()
                }
            ]}>
                 <AutoFetchTable columns={columns}
                                 onRef={this.onRefTabOne}
                                 fetchCallBack={(data)=>this.fetchCallBack(data)}
                                 rowSelection={{
                                    selectedRowKeys,
                                    onChange: this.onSelectChange,
                                }}
                                 flagShowReset={false}
                                 precondition={{status:10}} // 10:待调拨列表 20:调拨中列表
                                pageSize={50}
                                searchFormOptions={searchFormOptions}
                                fetchApi={'/service/mg/allocate/list'} />
                {/*出库详情弹窗*/}
                {showDetails&&<EssaModal title={Lang({id:"DingDanXiangQing",default:"订单详情"})}
                                        open={showDetails}
                                        width={750}
                                        onCancel={()=>this.handleCloseDetails()}
                                        footer={[
                                           <Button onClick={() => this.handleCloseDetails()} key={"close"}>
                                              {Lang({id:"GuanBi",default:"关闭"})}
                                           </Button>,
                                       ]}>
                    <Spin spinning={loading}>
                       {selectOrder&&selectOrder.orderNumber&&extra.currencySymbol&&<OrderDetails
                           data={selectOrder}
                           currencySymbol={extra.currencySymbol} />}
                    </Spin>
                </EssaModal>}
                {showTip&&<EssaModal title={Lang({id:"DiaoBo",default:"调拨"})}
                                     open={showTip}
                                     width={492}
                                     onCancel={()=>this.openBatchTransfer(false)}
                                     onOk={()=>this.batchTransfer()}>
                    <div className={"transferWrapPop"}>
                        <p className={"black89 font_16"}>
                            {Lang({id:"HeJiNGeKeHuNGeDingDan",default:"合计 {0} 个客户，{1} 个订单",params:[selectOrder.buyerCode,selectedRowKeys.length]})}
                        </p>
                        <p> {Lang({id:"HeJi",default:"合计"})} :
                            {selectOrder.skuNum}
                            {Lang({id:"Kuan",default:"款"})}，
                            {selectOrder.quantity}
                            {Lang({id:"Xiang",default:"箱"})}，
                            {selectOrder.volume}m³
                        </p>
                        <div className={"flex-item-between mt_16"}>
                            <div className={"greyBg"}>
                                {Lang({id:"DangQianCangKu",default:"当前仓库"})}
                                <p className={"black89"}>{selectOrder.fromWarehouseName}</p>
                            </div>
                            <i className="ri-arrow-right-line color-black"></i>
                            <div className={"greyBg"}>
                                {Lang({id:"MuDiCangKu",default:"目的仓库"})}
                                <p className={"black89"}>{selectOrder.toWarehouseName}</p>
                            </div>
                        </div>
                    </div>
                </EssaModal>}
            </PageCommon>
        )
    }
}